import React from 'react';

import loading from '../assets/images/loading.svg';
import loadingWhite from '../assets/images/loading-white.svg';

import '../assets/stylesheets/Loader.scss';

export const Loader = ({inverted = false}) => {

    return (
        <div className="Loader">
            <img src={inverted ? loadingWhite : loading} role="presentation"/>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Loader.js